<template>
  <v-card height="100%">
    <v-card-title>
      <span class="caption" style="margin-left: auto; margin-right: 0;" v-t="{path: 'info.scopes.SCOPE'+item.scope+'.TITLE', locale: version}"></span>
    </v-card-title>
    <v-card-title class="body-2" v-t="{path: 'ITEM'+item.id+'.TITLE', locale: version}">
    </v-card-title>
    <v-spacer></v-spacer>
    <v-card-title>
      <span style="float: left;">
        <v-icon color="deep-purple lighten-4" v-if="item.complexity == 1">radio_button_checked</v-icon>
        <v-icon color="deep-purple lighten-4" v-if="item.complexity != 1">radio_button_unchecked</v-icon>
        <v-icon color="deep-purple lighten-1" v-if="item.complexity == 2">radio_button_checked</v-icon>
        <v-icon color="deep-purple lighten-1" v-if="item.complexity != 2">radio_button_unchecked</v-icon>
        <v-icon color="deep-purple darken-4" v-if="item.complexity == 3">radio_button_checked</v-icon>
        <v-icon color="deep-purple darken-4" v-if="item.complexity != 3">radio_button_unchecked</v-icon>
      </span>
      <span class="caption" style="margin-left: auto; margin-right: 0; cursor: pointer">
        <v-icon v-on:click="showDescription(item.id)">info_outline</v-icon>
      </span>
    </v-card-title>
    <v-card-title class="caption" style="display: none;" v-bind:id="'exp' + item.id">
      <span v-t="{path: 'ITEM'+item.id+'.ITEM_EXPLANATION', locale: version}"></span>
    </v-card-title>
    <v-card-actions>
      <v-btn class="mt-0" color="primary" block v-on:click="showIncorporate(item.id)">
        <span v-if="short" class="caption" v-t="{path: 'info.incorporateDialog.BUTTON_SHORT', locale: version}"></span>
        <span v-else class="caption" v-t="{path: 'info.incorporateDialog.BUTTON', locale: version}"></span>
        <v-icon light small right>live_help</v-icon>
      </v-btn>
    </v-card-actions>
    <evaloe-assist :version="version"
                   :incorporateHelp="incorporateHelp"
                   :incorporateKey="item.id"
                   v-on:close="closeAssist"
    ></evaloe-assist>
    <description-popup :version="version"
                       :bodyPath="'ITEM'+item.id+'.ITEM_EXPLANATION'"
                       titlePath="questionnaire.itemHelpDialog.TITLE"
                       :showPopup="popupDescription"
                       v-on:close="closeDescription">
    </description-popup>
  </v-card>
</template>

<script>
  import EvaloeAssist from '@/components/questionnaires/EvaloeAssist'
  import DescriptionPopup from '@/components/questionnaires/descriptionPopup'
  export default {
    name: 'evaloe-item-card',
    props: ['item', 'version', 'short'],
    components: {
      'description-popup': DescriptionPopup,
      'evaloe-assist': EvaloeAssist
    },
    data () {
      return {
        incorporateHelp: false,
        popupDescription: false
      }
    },
    methods: {
      showIncorporate: function (itemId) {
        this.incorporateKey = itemId
        this.incorporateHelp = true
      },
      showDescription: function (itemId) {
        this.popupDescription = true
      },
      showAssist: function () {
        this.incorporateHelp = true
      },
      closeAssist: function () {
        this.incorporateHelp = false
      },
      closeDescription: function () {
        this.popupDescription = false
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/questionnaires/EvaloeItemCard.vue